import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export async function startCoinPayment(navigate, { kind, item_id = null, qty = 1, payload = {} }) {
  try {
    const { data } = await api.post("/bullion/pay-requests", { kind, item_id, qty, payload });
    navigate(`/wallet?pay=${data.id}`);
    return true;
  } catch (e) {
    toast.error(formatApiError(e.response?.data?.detail));
    return false;
  }
}
